/* eslint-disable */
// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());





import 'headroom.js/dist/jQuery.headroom';
import Headroom from 'headroom.js/dist/headroom.min.js';
// var myElement = document.querySelector("#header");
// var options = {
//   tolerance: 5,
//   offset : 100,
// };
// var headroom  = new Headroom(myElement, options);
// headroom.init();

import Swiper from 'swiper/swiper-bundle.min.js';
// new Swiper('.swiper_front', {
//   loop: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
// });

// SCROLL TO TOP:
var bt = jQuery('.back_top');
$(window).scroll(function () { 
  ($(this).scrollTop() > 100 ? bt.fadeIn('fast') : bt.fadeOut('fast')); 
});
bt.click(function () {
  $("html, body").animate({
    scrollTop: 0
}, 500);
});


// kotwice
$('a').click(function(e){
  var target = e.target.hash;
  var n = target.includes("#");

  if(n) { 
    var item = $(target)[0].offsetTop;
    $("html, body").animate({
      scrollTop: item-10
    }, 500);
  }
})



jQuery('.opener').on('click',  function(){
  if(jQuery(this).hasClass('open')) {
    jQuery(this).removeClass('open')
  } else {
    jQuery('.opener').removeClass('open')
    jQuery(this).addClass('open')
  }
})


jQuery( ".back_top" ).on('click', function(){
  $("html, body").animate({
    scrollTop: 0
  }, 500);
})

// jQuery( window ).scroll(function(e) {
//   if(jQuery( window ).height() < jQuery( ".back_top" ).offset().top+200) {
//     jQuery( ".back_top" ).fadeIn('slow');
//   } else {
//     jQuery(".back_top").fadeOut('slow');
//   }
// });
  


// WEBPACK FOOTER //
// ./scripts/main.js